import { Chapter, FadeUp } from "@/components/motion";

const BENEFITS = [
  { num: "01", title: "MENOS GESTIONES", desc: "Tu tiempo es para tu negocio, no para buscar técnicos ni coordinar visitas.", span: "lg:col-span-7" },
  { num: "02", title: "UN ÚNICO PUNTO DE CONTACTO", desc: "Una única entidad para gestionar todas las incidencias físicas de tu comercio.", span: "lg:col-span-5" },
  { num: "03", title: "TÉCNICOS ESPECIALIZADOS", desc: "Cada incidencia se comunica al profesional correspondiente a su especialidad.", span: "lg:col-span-5" },
  { num: "04", title: "RAPIDEZ", desc: "Compromiso de técnico en tu comercio en menos de 24 horas hábiles, según las condiciones del servicio.", span: "lg:col-span-7" },
  { num: "05", title: "TRANQUILIDAD", desc: "Tu equipo se centra en el negocio. La incidencia deja de ser tu problema.", span: "lg:col-span-12" },
];

export default function Benefits() {
  return (
    <section className="relative py-32 lg:py-44" data-testid="section-beneficios">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <Chapter num="05" label="QUÉ CONSIGUES" className="mb-12" />
        <FadeUp>
          <h2 className="font-display font-800 uppercase leading-[0.98] tracking-tight text-4xl sm:text-6xl lg:text-7xl text-offwhite mb-16 max-w-4xl">
            Lo que cambia <span className="font-cormorant normal-case font-medium text-metal">desde el día uno.</span>
          </h2>
        </FadeUp>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {BENEFITS.map((b, i) => (
            <FadeUp key={b.num} delay={i * 0.06} className={b.span}>
              <div className="group relative h-full border border-silver/10 bg-panel/40 p-8 md:p-10 hover:border-silver/30 hover:bg-panel/70 transition-colors duration-500">
                <span className="absolute -top-px -left-px w-4 h-4 border-t border-l border-silver/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="absolute -bottom-px -right-px w-4 h-4 border-b border-r border-silver/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="font-mono text-[10px] tracking-[0.3em] text-steel block mb-6">{b.num}</span>
                <h3 className="font-oswald font-600 uppercase text-2xl md:text-3xl tracking-wide text-offwhite mb-4 group-hover:text-silver transition-colors duration-300">
                  {b.title}
                </h3>
                <p className="text-mist text-sm md:text-base leading-relaxed max-w-lg">{b.desc}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
